import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 半角数のみ, 必須入力, 日付書式} from '@/type/validation/validator';

export interface 譲渡検索条件型 {
    部署コード: string;
    譲渡日付FROM: 日付型;
    譲渡日付TO: 日付型;
    メーカー名: string;
    商品名カナ: string;
    譲渡医療機関コード: string | null;
    伝票番号: string;
    登録者コード: string;
}

export interface 譲渡削除依頼型 {
    譲渡SEQ: number;
    更新バージョン: number;
}

export interface 譲渡修正依頼型 {
    譲渡修正一覧: 譲渡修正型[];
    譲渡先部署: string;
}

export interface 譲渡修正型 {
    譲渡確定対象: string;
    譲渡SEQ: number;
    譲渡伝票番号: string;
    譲渡伝票行番号: number;
    更新バージョン: number;
    譲渡医療機関コード: string;
    譲渡担当薬剤師: string;
    商品コード: string;
    有効期限: 日付型;
    ロット番号: string;
    譲渡数: number;
    薬価: number;
    譲渡単価: number;
    消費税率: number;
    バラ単位区分: string;
    単位名: string;
    譲渡金額: number;
    手数料: number;
    譲渡日付: 日付型;
    備考: string;
    譲渡入力方法: string;
    登録者氏名: string;
    商品名: string;
    規格容量: string;
    メーカー名: string;
    修正前譲渡: 修正前譲渡型;
}

export interface 修正前譲渡型 {
    ロット番号: string;
    譲渡数: number;
    譲渡単価: number;
    消費税率: number;
    有効期限: 日付型;
    手数料: number;
    備考: string;
}

export type 日付型 = Date | null;

export interface 譲渡修正検索結果型 {
    譲渡修正一覧: 譲渡修正型[];
    アラートメッセージ: string;
}

// バリデーション用のマップ
export const 譲渡検索条件バリデータ一覧: Validator[] = [
    {
        name: '商品名カナ',
        constraints: [
            {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
        ],
    },
    {
        name: '譲渡日付FROM',
        constraints: [
            {method: 必須入力, message: '譲渡年月日Fromは入力必須項目です'},
            {method: 日付書式, message: '譲渡年月日Fromの書式を正しく入力してください'},
        ],
    },
    {
        name: '譲渡日付TO',
        constraints: [
            {method: 日付書式, message: '譲渡年月日Toの書式を正しく入力してください'},
        ],
    },
    {
        name: '譲渡医療機関コード',
        constraints: [
            {method: 必須入力, message: '譲渡医療機関は選択必須項目です'},
        ],
    },
    {
        name: '伝票番号',
        constraints: [
            {method: 半角数のみ, message: '伝票番号は半角数字で入力してください'},
        ],
    },
];

